import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTl = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1200 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1200 600V0H0v600z", fill: "#dc241f" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v600l600-300z", fill: "#ffc726" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v600l400-300z" }), /* @__PURE__ */ React.createElement("path", { d: "M92.858 208.928l19.76 189.181 95.212-164.663-173.817 77.251 186.025 39.67-127.18-141.44", fill: "#fff" }));
const ForwardRef = forwardRef(SvgTl);
const Memo = memo(ForwardRef);
export default Memo;
